import React, { Component } from "react";
import { Container, Col, Row } from "react-bootstrap";

export default class VistaDatosDecesoHermana extends Component {
  render() {
    const formDeceso = this.props.DatosMonja.sister.decease ? (
      <Container>
        <Row>
          <Col lg="6" className="border">
            <h6>Fecha de Defunción</h6>
            <p>{this.props.DatosMonja.sister.decease}</p>
          </Col>
          <Col lg="6" className="border">
            <h6>Lugar de Defunción</h6>
            <p>{this.props.DatosMonja.sister.deceasePlace}</p>
          </Col>
        </Row>
        <Row>
          <Col lg="6" className="border">
            <h6>Fecha de Entierro</h6>
            <p>{this.props.DatosMonja.sister.burial}</p>
          </Col>
          <Col lg="6" className="border">
            <h6>Lugar de entierro</h6>
            <p>{this.props.DatosMonja.sister.burialPlace}</p>
          </Col>
        </Row>
      </Container>
    ) : (
      <p className="ml-3">No hay datos actualmente</p>
    );
    return <React.Fragment>{formDeceso}</React.Fragment>;
  }
}
